import { render, staticRenderFns } from "./SSOSignIn.vue?vue&type=template&id=635f7b3a&scoped=true"
import script from "./SSOSignIn.vue?vue&type=script&lang=js"
export * from "./SSOSignIn.vue?vue&type=script&lang=js"
import style0 from "./SSOSignIn.vue?vue&type=style&index=0&id=635f7b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f7b3a",
  null
  
)

export default component.exports